import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loader',
    standalone: true,
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
    constructor() {
    }

    ngOnInit(): void {
    }
}
